import { render, staticRenderFns } from "./ticketsForm.vue?vue&type=template&id=12781f94&scoped=true&"
import script from "./ticketsForm.vue?vue&type=script&lang=js&"
export * from "./ticketsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12781f94",
  null
  
)

export default component.exports